import React from "react";
import usePageMeta from "hooks/usePageMeta";

const NotFound = () => {
  usePageMeta({
    title: "페이지를 찾을 수 없습니다",
    description: "요청하신 페이지를 찾을 수 없습니다.",
    robots: "noindex,follow",
    canonicalPath: "/not-found",
  });

  return (
    <div className="not-found__wrapper">
      <h1>404 - Page Not Found</h1>
      <p>페이지를 찾을 수 없습니다.</p>
    </div>
  );
};

export default NotFound;
